module.exports = __webpack_public_path__ + "img/message-closed-envelope.2dcedf0e.png";